import React, { useState, useEffect, useContext, useRef } from "react";
import Swal from "sweetalert2";

import userDefaultImage from "../../images/default-profile.png";
import ProjectDescription from "./ProjectDescription";
import ProjectStatus from "./ProjectStatus";
import PageViewCounter from "./pageViewCounter";
import ProjectSupporter from "./ProjectSupporter";
import errorRedIcon from "../../images/errorRedIcon.png";
import { Link, useNavigate } from "react-router-dom";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UserContext } from "../../contexts/UserContext";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";
import { STATE, Stars, fmtDate } from "../ProjectDetails/FeedbackModal";

export default function POSingleProject({
  project,
  users,
  filtering,
  page = "",
}) {
  const { projects, setProjects, updateProjects, setUpdateProjects, sanitize } =
    useContext(AppContext);
  const { API_URL } = useContext(UrlContext);
  const [projectOwnerImage, setProjectOwnerImage] = useState(userDefaultImage);
  const [showProjectRow, setShowProjectRow] = useState(!filtering);
  // const [date, setDate] = useState('')
  // const [time, setTime] = useState('')
  const { adminUser } = useContext(UserContext);
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [projectLost, setProjectLost] = useState(false);
  const [otherSelected, setOtherSelected] = useState(false);
  const [reasonLost, setReasonLost] = useState("");
  const [reasonLostOptions, setReasonLostOptions] = useState([
    "Other candidates were selected",
    "Consultants not a good fit",
    "Consultants too expensive",
    "Client proposal was not won",
    "No feedback from the client",
    "Delivery too slow",
    "No profiles found",
    "Project not won or postponed",
    "Lost to competition",
    "Others",
  ]);

  const [projectStatus, setProjectStatus] = useState("");

  const [loadingPopup, setLoadingPopup] = useState(false);
  const [loadingClosePopup, setLoadingClosePopup] = useState(false);

  const [data, setData] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const descriptionButtonRef = useRef();
  const projSupporterRef = useRef();
  const projStatusRef = useRef();
  const projDeleteRef = useRef();
  const projExCall = useRef();
  const accountDetailsRef = useRef();
  const navigate = useNavigate();
  const databaseLink = "https://images.expertpowerhouse.com";

  useEffect(() => {
    setTimeout(() => {
      setShowProjectRow(true);
    }, 100);
  }, []);

  useEffect(() => {
    const ownerName = project.owner_name;
    const selectedUser = users.find((user) => {
      if (ownerName && ownerName.includes(" ")) {
        if (user.fullname === ownerName || user.username === ownerName) {
          return true;
        } else {
          // const ownerNameList = ownerName.split(" ");
          // const username = user.username;
          // const fullname = user.fullname;

          // for (let i = 0; i < ownerNameList.length; i++) {
          //   if (
          //     fullname.includes(ownerNameList[i]) ||
          //     username.includes(ownerNameList[i])
          //   ) {
          //     return true;
          //   }
          // }
        }
      }
      return false;
    });
    if (selectedUser) {
      if (selectedUser.profilePicture) {
        if (selectedUser.profilePicture.includes("data:image")) {
          setProjectOwnerImage(selectedUser.profilePicture);
        } else {
          setProjectOwnerImage(`${databaseLink}${selectedUser.profilePicture}`);
        }
      } else {
        setProjectOwnerImage(userDefaultImage);
      }
    } else {
      setProjectOwnerImage(userDefaultImage);
    }
  }, [project.owner_name, users]);

  // useEffect(() => {
  //    if (project.date_created) {
  //       const timeString = project.date_created.split(' ')[4];
  //       const [hours, minutes, seconds] = timeString.split(':');
  //       const formattedTime = `${hours}:${minutes}`;
  //       setTime(formattedTime);
  //    }
  // }, [project.date_created]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_URL}get-participated-experts?projectId=${project.id}`
      );
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDelete = () => {
    setDeletePopup(false);
    setLoadingPopup(true);
    const projectID = project.id;
    const projectData = {
      projectID,
    };
    const projectList = projects.filter((proj) => proj.id !== projectID);
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}delete-project`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(projectData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          setProjects(projectList);
          Swal.fire({
            title: "Success!",
            text: data.message,
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          setShowProjectRow(false);
        } else {
          setUpdateProjects(!updateProjects);
          Swal.fire({
            title: "Error",
            text: data.message,
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          timer: 1500,
        });
      });
  };

  const onOptionChange = (value) => {
    // console.log(value)
    if (value) {
      setReasonLost(value);
      if (value === "Others") {
        setOtherSelected(true);
      } else {
        setOtherSelected(false);
      }
    }
  };

  const goProjectDetails = (e) => {
    if (
      descriptionButtonRef.current &&
      descriptionButtonRef.current.contains(e.target)
    )
      return;
    if (projSupporterRef.current && projSupporterRef.current.contains(e.target))
      return;
    if (projStatusRef.current && projStatusRef.current.contains(e.target))
      return;
    if (projDeleteRef.current && projDeleteRef.current.contains(e.target))
      return;
    if (projExCall.current && projExCall.current.contains(e.target)) return;
    if (
      accountDetailsRef.current &&
      accountDetailsRef.current.contains(e.target)
    )
      return;
    navigate(`/app/ProjectDetails/${project.id}`);
  };

  const handleSubmitReason = () => {
    console.log(reasonLost);
    setProjectLost(false);
    setLoadingClosePopup(true);
    setProjectStatus("Project Closed (Lost)");
    const selectedProjectStatus = "Project Closed (Lost)";
    const projectID = project.id;
    const selectedProject = projects.filter((proj) => proj.id === projectID)[0];
    const modifiedProject = {
      ...selectedProject,
      status: selectedProjectStatus,
    };
    const projectData = {
      selectedProjectStatus,
      projectID,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}update-project-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ data: projectData, reason: reasonLost }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingClosePopup(false);
        if (data.status === "success") {
          // setReturnSuccess(true);
          setProjects(
            projects.map((project) =>
              project.id === modifiedProject.id ? modifiedProject : project
            )
          );
          Swal.fire({
            title: "Success!",
            text: data.message,
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          // setTimeout(() => {
          //   setReturnSuccess(false);
          // }, 1500);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error updating the project status.",
            text: "Please try again.",
            confirmButtonText: "OK",
          });
          // setReturnError(true);
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        // setReturnError(true);
        Swal.fire({
          icon: "error",
          title: "Database connection error!",
          text: "Please logout and try again.",
          confirmButtonText: "OK",
        });
        console.log(err);
      });
  };

  return (
    <>
      {showProjectRow && (
        <div
          onClick={goProjectDetails}
          key={project.id}
          onMouseOver={() => setShowDeleteBtn(true)}
          onMouseLeave={() => setShowDeleteBtn(false)}
        >
          <div className="project-table-row">
            <div className="row-top-div">
              <ul className="list-unstyled form-inline">
                <li className="project-title-td">
                  <div className="tooltip-div-onhover">
                    <Link to={`/app/ProjectDetails/${project.id}`}>
                      <span className="project-name-tag">{project.name}</span>
                    </Link>
                    <span
                      className="tooltiptext-onhover"
                      dangerouslySetInnerHTML={{ __html: project?.description }}
                    ></span>
                  </div>
                  <i
                    className="desc-icon-toedit fa-regular fa-pen-to-square"
                    ref={descriptionButtonRef}
                    onClick={() => {
                      navigate("/app/ProjectSetup/" + project.id);
                    }}
                  ></i>
                  {(project.feedbackState === "due" || project.feedbackState === "received") && (
                    <span className="group relative ml-2 inline-flex align-middle">
                      <span
                        tabIndex={project.companyReview ? 0 : undefined}
                        aria-describedby={project.companyReview ? `fb-review-${project.id}` : undefined}
                        title={project.feedbackState === "due" ? "Project finished. Request client feedback." : undefined}
                        className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 focus:outline-none focus-visible:ring-2 ${STATE[project.feedbackState].chip}`}
                      >
                        <span className={`h-1.5 w-1.5 rounded-full ${STATE[project.feedbackState].dot}`} aria-hidden="true" />
                        {STATE[project.feedbackState].label}
                        {project.feedbackState === "received" && project.companyReview?.rating && (
                          <span className="inline-flex items-center gap-0.5 border-l border-emerald-200 pl-1.5">
                            <i className="fa-solid fa-star text-[10px] text-amber-400" aria-hidden="true" />
                            {project.companyReview.rating}
                          </span>
                        )}
                      </span>

                      {/* Hover card: the client's review of expertpowerhouse only (expert ratings live in the project's feedback popup) */}
                      {project.feedbackState === "received" && project.companyReview && (
                        <div
                          id={`fb-review-${project.id}`}
                          role="tooltip"
                          className="pointer-events-none absolute left-0 top-full z-[60] w-[320px] pt-2 opacity-0 transition duration-150 group-focus-within:pointer-events-auto group-focus-within:opacity-100 group-hover:pointer-events-auto group-hover:opacity-100 motion-reduce:transition-none"
                        >
                          <div className="rounded-2xl border border-slate-200 bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.12),transparent_45%),linear-gradient(to_bottom,#ffffff,#f8fafc)] p-[16px] text-left shadow-[0_24px_60px_rgba(15,23,42,0.22)]">
                            <p className="m-0 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#365561]">Client's review of expertpowerhouse</p>
                            <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-2">
                              <Stars value={project.companyReview.rating} size="text-base" />
                              {project.companyReview.wouldRecommend != null && (
                                <span
                                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                                    project.companyReview.wouldRecommend ? "bg-emerald-50 text-emerald-800" : "bg-red-50 text-red-700"
                                  }`}
                                >
                                  <i className={`fa-solid ${project.companyReview.wouldRecommend ? "fa-thumbs-up" : "fa-thumbs-down"}`} aria-hidden="true" />
                                  {project.companyReview.wouldRecommend ? "Would recommend" : "Would not recommend"}
                                </span>
                              )}
                            </div>
                            {project.companyReview.comment && (
                              <p className="m-0 mt-[12px] line-clamp-6 whitespace-pre-wrap rounded-xl bg-slate-50 px-3.5 py-[12px] text-sm leading-relaxed text-slate-800">
                                {project.companyReview.comment}
                              </p>
                            )}
                            <p className="m-0 mt-2 text-xs text-slate-500">Submitted {fmtDate(project.companyReview.submittedAt)}</p>
                          </div>
                        </div>
                      )}
                    </span>
                  )}
                  {/* <div className="tooltip-div-po" ref={descriptionButtonRef}>
                    <ProjectDescription
                      project_desc={project?.description}
                      project_id={project?.id}
                    />
                  </div> */}

                  <div>
                    <Link
                      to={
                        !sanitize
                          ? `/app/AccountDetails/${project.id}`
                          : "/app/ProjectsOverview"
                      }
                      ref={accountDetailsRef}
                    >
                      <p
                        className="client-name-tag colored-span"
                        style={sanitize ? { fontStyle: "italic" } : null}
                      >
                        {sanitize ? " Sanitized Mode " : project.client_name}
                      </p>
                    </Link>
                  </div>
                </li>

                <li className="po-con-exp-li" ref={projExCall}>
                  <span className="po-con-exp-tag">
                    {project.cons_exp === "exp" ? (
                      <>
                        <i className="fa-solid fa-phone-volume"></i>
                        <span>Expert Call</span>
                      </>
                    ) : project.cons_exp === "int" ? (
                      <>
                        <i className="fa-solid fa-suitcase"></i>
                        <span>Interim</span>
                      </>
                    ) : null}
                  </span>
                </li>

                <li className="zohoId-td">
                  <span className="zohoId-tag">{project.zoho_id}</span>
                </li>
                <li className="project-participation-icons-td">
                  <div className="all-participation-div">
                    <span>
                      <div className="total-experts" title="Added consultants">
                        <i className="fa-solid fa-users" />
                        <span>{project.total_expert_inside}</span>
                      </div>
                    </span>
                    <span>
                      <div
                        className="interested-experts"
                        title="Interested consultants"
                      >
                        <i className="fa-solid fa-user" />
                        <span>{project.total_interested_expert}</span>
                      </div>
                    </span>
                    <span>
                      <div
                        className="experts-shared"
                        title="Total experts shared"
                      >
                        <i className="fa-solid fa-share-alt" />
                        <span>{project.total_expert_shared}</span>
                      </div>
                    </span>
                    <span
                      onMouseEnter={() => {
                        fetchData();
                        setShowTooltip(true);
                      }}
                      onMouseLeave={() => setShowTooltip(false)}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <div
                        className="participated-experts"
                        title="Participated consultants"
                      >
                        <i className="fa-regular fa-user third-icon" />
                        <i className="fa-solid fa-check icon-absolute" />
                        <span>{project.total_participated_expert}</span>
                      </div>
                      {showTooltip &&
                        page === "AccountDetails" &&
                        project.cons_exp !== "exp" &&
                        data && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: "100%",
                              transform: "translateX(-50%)",
                              backgroundColor: "#fff",
                              padding: "8px",
                              borderRadius: "4px",
                              boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                              zIndex: 100,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {data.experts?.map((expert, index) => (
                              <div key={expert.id}>
                                <a
                                  href={`/app/ProjectInformation/${project.id}/${expert.id}/0/1`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {expert.name}
                                </a>
                              </div>
                            ))}
                          </div>
                        )}
                    </span>
                    {project.isLinkCreated && (
                      <span>
                        <div className="experts-shared" title="Client visits">
                          <PageViewCounter project={project.id} />
                        </div>
                      </span>
                    )}
                  </div>
                </li>
                <li className="gap1-td"></li>
                <li className="status-bar-td" ref={projStatusRef}>
                  <ProjectStatus
                    project_status={project.status}
                    project_id={project.id}
                    setProjectLost={setProjectLost}
                    projectStatus={projectStatus}
                    setProjectStatus={setProjectStatus}
                  />
                </li>
              </ul>
            </div>
            <div className="row-bottom-div" style={{ position: "relative" }}>
              <div className="project-owner">
                <img
                  src={projectOwnerImage}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = userDefaultImage;
                  }}
                  width={24}
                  height={24}
                  className="rounded-circle"
                  title={project.owner_name}
                  alt=""
                />
                <i className="fa-solid fa-circle-check" />
              </div>
              <div ref={projSupporterRef}>
                <ProjectSupporter users={users} project={project} />
              </div>
              <div className="date-time-div">
                <p className="colored-span date-time-text">
                  <i className="fa-regular fa-calendar-days" />
                  <input
                    type="datetime-local"
                    className="date-without-icon"
                    value={new Date(project.date_created)
                      .toISOString()
                      .slice(0, 16)}
                    readOnly
                    title="Date Created"
                  />
                  {project.projDeadline ? (
                    <>
                      <i class="fa fa-bell-o" aria-hidden="true"></i>
                      <input
                        type="date"
                        className="date-without-icon"
                        value={new Date(project.projDeadline)
                          .toISOString()
                          .slice(0, 10)}
                        readOnly
                        title="Deadline"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </p>
                {adminUser && showDeleteBtn && (
                  <i
                    ref={projDeleteRef}
                    className="deleteProjectBtn fa fa-trash"
                    title="Delete Project"
                    onClick={() => setDeletePopup(true)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <div>
              <center>
                <img src={errorRedIcon} width="50px" height="50px" alt="" />
                <p>
                  <strong>WARNING!</strong> Project will be permanently removed!
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setDeletePopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={handleDelete}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
      {projectLost && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <div>
              <center>
                {/* <img src={errorRedIcon} width="50px" height="50px" alt="" /> */}
                <p>
                  <strong>Reason for Project Lost</strong>
                </p>
                <br />
                <select
                  className="resasonsLost"
                  onChange={(e) => onOptionChange(e.target.value)}
                  // value={projectStatus}
                >
                  <option value="">Select an option</option>
                  {reasonLostOptions.map((reason) => (
                    <option value={reason}>{reason}</option>
                  ))}
                </select>
                <br />
                <br />
                {otherSelected && (
                  <>
                    <input
                      type="text"
                      placeholder="Other reason"
                      onChange={(e) => setReasonLost(e.target.value)}
                    />
                    <br></br>
                    <br></br>
                  </>
                )}
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => {
                    setProjectLost(false);
                    setOtherSelected(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={handleSubmitReason}
                >
                  Submit
                </button>
              </center>
            </div>
          </div>
        </div>
      )}

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                Deleting project. Please wait . . .
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}

      {loadingClosePopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
